import { createContext } from 'utils/react-helpers';

const [RouteFilterProvider, useRoute] = createContext({
  name: 'RouteFilterContext',
});

export { RouteFilterProvider, useRoute };
